<template>
  <Modal
    :title="modalTitle"
    :saving="isSaving"
    :disabled="isDefault"
    @hide-modal="$emit('hide-modal')"
    @submit="handleSubmit"
  >
    <equipment-type-form
      ref="form"
      :equipment-type="equipmentType"
      :component-types="componentTypes"
    />
    <template v-if="isEditing" #delete>
      <sera-button
        v-if="equipmentType.links.archive"
        type="danger"
        text="Archive"
        :saving="archiving"
        @click="handleArchiveAction(true)"
      />
      <sera-button
        v-else-if="equipmentType.links.unarchive"
        text="Unarchive"
        outline
        :saving="archiving"
        @click="handleArchiveAction(false)"
      />
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapState } from "vuex";

import SeraButton from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
import EquipmentType from "@/EquipmentTypes/EquipmentType.js";
import EquipmentTypeForm from "@/EquipmentTypes/EquipmentTypeForm.vue";

export default {
  components: {
    EquipmentTypeForm,
    Modal,
    SeraButton
  },
  props: {
    equipmentType: {
      type: EquipmentType,
      default: () => null
    }
  },
  emits: ["hide-modal"],
  data() {
    return {
      isSaving: false,
      archiving: false
    };
  },
  computed: {
    ...mapState(["componentTypes"]),
    isEditing() {
      console.log("eq: ", this.equipmentType);
      return this.equipmentType && this.equipmentType.id > -1;
    },
    isDefault() {
      if (this.equipmentType && this.equipmentType.is_default) {
        return true;
      }

      return false;
    },
    modalTitle() {
      return this.isEditing ? "Edit Equipment Type" : "Create Equipment Type";
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    ...mapActions([
      "createEquipmentType",
      "fetchEquipmentTypes",
      "fetchComponentTypes",
      "updateEquipmentType",
      "archiveEquipmentType",
      "unarchiveEquipmentType"
    ]),
    refresh() {
      this.fetchComponentTypes();
    },
    async handleArchiveAction(archive) {
      this.archiving = true;
      try {
        if (archive) {
          await this.archiveEquipmentType(this.equipmentType.links.archive);
        } else {
          await this.unarchiveEquipmentType(this.equipmentType.links.unarchive);
        }
        window.notify.success("Equipment type updated successfully!");
        this.handleSuccess();
      } catch (e) {
        this.archiving = false;
        console.error(e);
      }
    },
    async handleSubmit() {
      const formData = await this.$refs.form.getData();
      if (!formData) return;
      this.isSaving = true;
      try {
        const saveFn = this.isEditing ? this.handleUpdate : this.handleCreate;
        await saveFn(formData);
        return this.handleSuccess();
      } catch (e) {
        this.isSaving = false;
        console.error(e);
      }
    },
    async handleCreate(data) {
      await this.createEquipmentType(data);
      window.notify.success("Equipment type created successfully!");
    },
    async handleUpdate(data) {
      await this.updateEquipmentType({
        link: this.equipmentType.links.edit,
        data
      });
      window.notify.success("Equipment type updated successfully!");
    },
    async handleSuccess() {
      await this.fetchEquipmentTypes();
      this.$emit("hide-modal");
    }
  }
};
</script>

<style lang="scss" scoped></style>
